import { DollarSign, Leaf, Zap } from "lucide-react";

const KpiCard = ({
  label,
  value,
  unit,
  delta,
  comparisonEnabled
}) => {
  const safeValue = Number.isFinite(value) ? value : 0;

  let percent = null;
  let isNew = false;

  if (comparisonEnabled && Number.isFinite(delta)) {
    const previous = safeValue - delta;

    if (previous === 0 && safeValue > 0) {
      isNew = true;
    } else if (previous !== 0) {
      percent = (delta / previous) * 100;
    }
  }

  let icon = null;

  if (label === "Energía Total") icon = <Zap size={18} />;
  if (label === "Costo Total") icon = <DollarSign size={18} />;
  if (label === "Emisiones CO₂") icon = <Leaf size={18} />;

  return (
    <div className="em-kpi-card">
      <div className="em-kpi-label">
        <span className="em-kpi-icon">{icon}</span>
        {label}
      </div>

      <div className="em-kpi-value">
        {safeValue.toFixed(2)}
      </div>

      <div className="em-kpi-unit">{unit}</div>

      {comparisonEnabled && Number.isFinite(delta) && (
        <div
          className={`em-kpi-delta ${
            delta >= 0 ? "positive" : "negative"
          }`}
        >
          {isNew ? (
            <span>Nuevo valor vs Período B</span>
          ) : (
            <>
              <span>
                {delta >= 0 ? "▲" : "▼"}{" "}
                {Math.abs(delta).toFixed(2)}
              </span>

              {percent !== null && (
                <span className="em-kpi-percent">
                  ({percent.toFixed(1)}%)
                </span>
              )}

              <span className="em-kpi-vs">
                {" "}vs Período B
              </span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default KpiCard;